import { RECEIVE_WORKOUT_DATA } from '../constants/actionTypes';

export const initialState = {};

export default function workoutDataReducer(state = initialState, action = {}) {
  switch (action.type) {
    case (RECEIVE_WORKOUT_DATA): {
      return state[action.id] ? { ...state, [action.id]: { ...state[action.id], ...action.workoutData } } : { ...state, [action.id]: { ...action.workoutData } };
    }
    default:
      return state;
  }
}
